import { render, staticRenderFns } from "./SalesDaily.vue?vue&type=template&id=2c1ca966"
import script from "./SalesDaily.vue?vue&type=script&lang=js"
export * from "./SalesDaily.vue?vue&type=script&lang=js"
import style0 from "./SalesDaily.vue?vue&type=style&index=0&id=2c1ca966&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports